<template>
  <div>
    <div
      v-if="evidences(value) && evidences(value).length > 0"
      class="evidence border-bottom shadow-sm"
    >
      <div
        class="row list no-gutters"
        v-if="evidencesInitial(value).length > 0"
      >
        <div class="item item-last col">
          <a class="py-2 px-3"
            ><strong class="mr-2">{{ $t("initial") }}</strong></a
          >
        </div>
      </div>
      <div
        v-for="e in evidencesInitial(value)"
        :key="`evidence-${e.id}`"
        class="row list no-gutters"
      >
        <div class="col item item-last">
          <a class="py-2 px-3" v-if="e.id">
            {{ e.name[authLocale] }}
          </a>
        </div>
      </div>
      <div
        class="row list no-gutters"
        v-if="evidencesFeatured(value).length > 0"
      >
        <div class="item item-last col">
          <a class="py-2 px-3"
            ><strong class="mr-2">{{ $t("featured") }}</strong></a
          >
        </div>
      </div>
      <div
        v-for="e in evidencesFeatured(value)"
        :key="`evidence-${e.id}`"
        class="row list no-gutters"
      >
        <div class="col-auto item item-last">
          <a class="py-2 px-3 h-100">
            <span class="text-success" v-if="e.choice === 'present'">
              <yes-icon></yes-icon>
            </span>
            <span class="text-danger" v-else>
              <no-icon></no-icon>
            </span>
          </a>
        </div>
        <div class="col item item-last">
          <a class="py-2 px-3" v-if="e.id">
            {{ e.name[authLocale] }}
          </a>
        </div>
      </div>
      <div
        class="row list no-gutters"
        v-if="evidencesPresent(value).length > 0"
      >
        <div class="item item-last col">
          <a class="py-2 px-3"
            ><strong class="mr-2">{{ $t("present") }}</strong></a
          >
        </div>
      </div>
      <div
        v-for="e in evidencesPresent(value)"
        :key="`evidence-${e.id}`"
        class="row list no-gutters"
      >
        <div class="col-auto item item-last">
          <a class="py-2 px-3 h-100">
            <span class="text-success">
              <yes-icon></yes-icon>
            </span>
          </a>
        </div>
        <div class="col item item-last">
          <a class="py-2 px-3" v-if="e.id">
            {{ e.name[authLocale] }}
          </a>
        </div>
      </div>
      <div class="row list no-gutters" v-if="evidencesAbsent(value).length > 0">
        <div class="item item-last col">
          <a class="py-2 px-3"
            ><strong class="mr-2">{{ $t("absent") }}</strong></a
          >
        </div>
      </div>
      <div
        v-for="e in evidencesAbsent(value)"
        :key="`evidence-${e.id}`"
        class="row list no-gutters"
      >
        <div class="col-auto item item-last">
          <a class="py-2 px-3 h-100">
            <span class="text-danger">
              <no-icon></no-icon>
            </span>
          </a>
        </div>
        <div class="col item item-last">
          <a class="py-2 px-3" v-if="e.id">
            {{ e.name[authLocale] }}
          </a>
        </div>
      </div>
    </div>
    <div v-else class="alert alert-secondary mt-3">
      {{ $t("noevidences") }}
    </div>
  </div>
</template>
<script>
import YesIcon from '@/components/Icons/Yes'
import NoIcon from '@/components/Icons/No'
import { mapGetters } from 'vuex'
export default {
  components: {
    YesIcon,
    NoIcon
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      evidence: null,
      keyword: null,
      showSymptoms: false
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      caseById: 'pcase/byId',
      evidences: 'pcase/evidences',
      evidencesPresent: 'pcase/evidencesPresent',
      evidencesAbsent: 'pcase/evidencesAbsent',
      evidencesInitial: 'pcase/evidencesInitial',
      evidencesFeatured: 'pcase/evidencesFeatured'
    })
  }
}
</script>
<style lang="scss">
.evidence {
  .evidence-list {
    max-height: 400px;
    overflow: auto;
  }
}
</style>
<i18n>
{
  "ka": {
    "addSymptom": "სიმპტომის დამატება",
    "searchSymptoms": "სიმპტომის ძიება",
    "initial": "საწყისი ჩივილები",
    "present": "ფიქსირდება",
    "absent": "არ ფიქსირდება",
    "featured": "მნიშვნელოვანი",
    "noevidences": "სიმპტომები არ არის შეყვანილი"
  },
  "en": {
    "addSymptom": "Add Evindence",
    "searchSymptoms": "Search Evidence",
    "initial": "Inital Symptoms",
    "present": "Present",
    "absent": "Absent",
    "featured": "Featured"
  }
}
</i18n>
